import React from "react";
import NipLogo from "./../../assets/nip-tag.svg";

export const Nip = ({ className, isValidProject }) => {
  return isValidProject ? (
    <div className={className}>
      <img src={NipLogo} />
    </div>
  ) : null;
};
